import { render, staticRenderFns } from "./zoho-chat.vue?vue&type=template&id=185ae0d0&scoped=true&"
import script from "./zoho-chat.vue?vue&type=script&lang=js&"
export * from "./zoho-chat.vue?vue&type=script&lang=js&"
import style0 from "./zoho-chat.vue?vue&type=style&index=0&id=185ae0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ae0d0",
  null
  
)

export default component.exports